import type { ShopSummary, UpdateShopBillingRequest } from '../../api/types.ts';
import { minorToMajorString, parseMajorMoneyToMinor, validateField } from '../config/configValidation.ts';

export interface ShopBillingFormState {
  commission: string;
  deviceFee: string;
}

export function initialShopBillingForm(shop: ShopSummary): ShopBillingFormState {
  return {
    commission: shop.commission_rate_bp_override === null ? '' : String(shop.commission_rate_bp_override),
    deviceFee:
      shop.device_monthly_fee_minor_override === null ? '' : minorToMajorString(shop.device_monthly_fee_minor_override),
  };
}

export function validateBillingCommission(value: string): string | null {
  if (value.trim() === '') return null;
  return validateField('commission_rate_bp', value);
}

export function validateBillingDeviceFee(value: string): string | null {
  if (value.trim() === '') return null;
  return validateField('device_monthly_fee_minor', value);
}

export function validateShopBillingForm(form: ShopBillingFormState): string | null {
  return validateBillingCommission(form.commission) ?? validateBillingDeviceFee(form.deviceFee);
}

export function buildShopBillingPatch(form: ShopBillingFormState, shop: ShopSummary): UpdateShopBillingRequest {
  const patch: UpdateShopBillingRequest = {};

  const desiredCommission = form.commission.trim() === '' ? null : Number.parseInt(form.commission.trim(), 10);
  if (desiredCommission !== shop.commission_rate_bp_override) {
    patch.commission_rate_bp_override = desiredCommission;
  }

  const desiredFee = form.deviceFee.trim() === '' ? null : parseMajorMoneyToMinor(form.deviceFee);
  if (desiredFee !== shop.device_monthly_fee_minor_override) {
    patch.device_monthly_fee_minor_override = desiredFee;
  }

  return patch;
}
